import { Colors } from '@be-brite/briteui';
import { Box, Text } from '../shared-components';

export const AssistantChatUserMessage = ({ message }) => {
  return (
    <Box
      css={`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
        width: 75%;
      `}
    >
      <Box
        css={`
          padding: 12px 16px;
          background: white;
          border: 1px solid ${Colors.Gray300};
          border-radius: 8px;
        `}
      >
        <Text label>{message.text}</Text>
      </Box>
      <Text helper color={Colors.Gray400}>
        {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </Text>
    </Box>
  );
};
